<template>
  <div class="flex flex-wrap items-center gap-2">
    <a :href="APP_STORE_URL" class="shrink-0" target="_blank" rel="noopener noreferrer">
      <img :src="AppStoreBadge" :alt="t('Xq4pLmT2vNs9RbKdWfHjZ')" class="h-10 w-auto" />
    </a>
    <a :href="GOOGLE_PLAY_URL" class="shrink-0" target="_blank" rel="noopener noreferrer">
      <img src="@/common/assets/images/stores/GooglePlay.png" :alt="t('Bn7cVzQ4hLxT1yMpRdGwK')" class="h-10 w-auto" />
    </a>
  </div>
</template>

<script setup lang="ts">
import AppStoreBadge from '@/common/assets/images/stores/AppStore.svg?url';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const APP_STORE_URL = 'https://apps.apple.com/ca/app/mb-ready/id6761196500';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=ca.mb.gov.mbready';
</script>
